<template>
        <el-table style="width:100%" :data="express_items" v-if="express_items.length">
                <el-table-column prop="name"  label="收件人姓名" current-row-key >
                </el-table-column>
                <el-table-column prop="mobile"  label="联系方式" >
                </el-table-column>
                <!-- @todo 这里应该是地区联动选择 -->
                <el-table-column prop="label_name"  label="寄件地址" >
                    <template slot-scope="scope">
                        {{scope.row.label_name + scope.row.address}}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="address"  label="详细地址" >
                </el-table-column> -->
                <el-table-column prop="express_company"  label="邮寄方式" >
                </el-table-column>
                <!-- <el-table-column prop="express_no"  label="单号" >
                </el-table-column>
                <el-table-column prop="status"  label="签收状态" >
                </el-table-column>
                <el-table-column prop="fee"  label="邮费" width="80" >
                </el-table-column> -->
                <el-table-column prop="memo"  label="备注信息" >
                </el-table-column>
                <el-table-column center label="操作" >
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" size="small" class="express-view" @click="handleShowExpress(scope.row.id)">编辑</el-button>
                        </span>
                        <span>
                            <el-button type="text" size="small" @click="handleDeleteExpress(scope.row.id)">删除</el-button>
                        </span>    
                    </template>
                </el-table-column>
        </el-table>
</template>
<script>
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import OrderService from '~/services/order';
export default {
    props:{
            express:{
            type:Array,
            required:true
        }
    },
    components:{
        DistrictLinkage
    },
    data(){
        return {
            options: [],
            statusOptions: []
        }
    },
    computed: {
        express_items: function() {
            return this.express.map( item => {
                let t = this.options.find(type => {
                    return type.value == item.express_company;
                });
                return Object.assign({}, item, {
                    express_company: t ? t.label: '==',
                    status: item.status == 1 ? '已签收' : '未签收'
                });
            });
        }
    },
    created() {
        this.options = OrderService.options();
        this.statusOptions = OrderService.statusOptions();
    },
    methods:{
        handleDeleteExpress(id){
            this.$emit('handleDeleteExpress',id);
        },
        handleShowExpress(id){
            this.$emit('handleShowExpress',id);
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/expressShowTable.vue